module.exports = __webpack_public_path__ + "static/media/person5.27a719ff.jpeg";